import React, {Component, useContext} from 'react';
import {connect} from '~/redux/connect';
import {pushSubview} from "~/actions/navigation_actions";

import css from './css.css';
import {getModelTooltip, getResultsValue, getSingleTitle, getSubview, getSubviewModelId} from "~/stateGetter";
import getLoadingState from "~/conclude/loading";
import NavigatableModelTable from "~/ui/ModelResultTable/NavigatableModelTable";
import {getActionPermissions, getCreatePath} from "../../stateGetter";
import LoadingContainer from "~/components/LoadingContainer/LoadingContainer";
import TableActions from "~/ui/TableActionBar/TableActions";
import TableSettings from "~/ui/TableActionBar/TableSettings";

import MessageList from "~/ui/MessageList/MessageList";
import { HStack, H1 } from "~/native-ui"
import Tooltip from '../Tooltip/Tooltip';
import SearchFilter from '../TableActionBar/SearchFilter';
import { SubViewContextProvider, ShowFilterMenuButton, FilterMenuList } from "./SubViewContext"

export class Subview extends Component {
    static propTypes = {};

    title = () => {
        let { loading, subviewTitle, resultsValue, trans } = this.props;

        if(loading) { return subviewTitle; }

        return resultsValue.total > 0 ? subviewTitle : trans('none')+' '+subviewTitle;
    };

    filterMessages = (messages) => {
        let filteredMessages = messages.filter(({source}) => {
            return ['results', 'customActionResult'].indexOf(source) > -1
        });

        return filteredMessages;
    };

    openInNew = () => {
        this.props.pushSubview();
    }

    pushSubView = () => {
        this.props.pushSubview({
            pathname: this.props.createPath.path,
            query: this.props.createPath.params
        });
    }

    renderTableBar = () => {
        let { singleTitle, pushSubview, parentActionPermissions, actionPermissions, trans } = this.props;

        let canAdd = parentActionPermissions.update && actionPermissions.create;

        return (
            <HStack space={2}>
                {/* <FilterMenu modelId={this.props.modelId} /> */}
                <ShowFilterMenuButton modelId={this.props.modelId} />
				<TableSettings modelId={this.props.modelId} />
                <TableActions
                    modelId={this.props.modelId}
                    onAdd={this.pushSubView}
                    canCreate={canAdd}
                    addText={singleTitle}
                    createTooltip={this.props.createTooltip}

                />
            </HStack>
        );
    };

    showTable() {
        let { resultsValue, loading } = this.props;
        return !loading && resultsValue.total > 0;
    }

    render() {
        let { modelId, loading, tooltip } = this.props;

        return (
            <SubViewContextProvider>
                <LoadingContainer ready={true} loading={loading} className={css.subviewContainer}>
                    <HStack alignItems="center">
                        <H1>
                            {this.title()}
                            {tooltip && tooltip.length && <Tooltip leftMargin tooltip={tooltip} modelId={modelId} />}
                        </H1>
                        <HStack flex={1} />
                        {this.renderTableBar()}
                    </HStack>

                    <HStack w="100%" space="0" py="3" alignItems="center">
                        <SearchFilter modelId={modelId} />
                        <FilterMenuList modelId={this.props.modelId} maxScroll={250} />
                    </HStack>

                    <MessageList modelId={modelId} filterMessages={this.filterMessages} />

                    {this.showTable() && 
                        <NavigatableModelTable
                            modelId={modelId}
                            subview
                            autoHidePagination
                            tableContainerClassName={css.subviewTableContainer }
                            showNoEntriesMessage={false}
                        />
                    }
                </LoadingContainer>
            </SubViewContextProvider>
        );
    }
}

const RXSubview = connect(
    (state, {modelId, name}) => {
        let subviewModelId = getSubviewModelId(state, modelId, name),
            subview = getSubview(state, modelId, name),
            loading = !getLoadingState(state, { loading: ['resultsValid'], modelId: subviewModelId }).loading,
            parentActionPermissions = getActionPermissions(state, modelId),
            actionPermissions = getActionPermissions(state, subviewModelId),
            resultsValue = getResultsValue(state, subviewModelId),
            createTooltip = getModelTooltip(state, subviewModelId, 'create');

        try {
            let subviewData = {
                singleTitle: getSingleTitle(state, subviewModelId),
            };

            return {
                loading,
                ...subviewData,
                parentActionPermissions, resultsValue,
                actionPermissions,
                createTooltip,
                subviewName: name,
                subviewTitle: subview.title,
                tooltip: subview.tooltip,
                maximizeTooltip: subview.maximizeTooltip,
                modelId: subviewModelId,
                createPath: getCreatePath(state, subviewModelId)
            }
        } catch(e) {
            throw e;
        }
    },
    (dispatch, { modelId, name }) => ({
        pushSubview: (path = '') => dispatch(pushSubview(modelId, name, path))
    }),
    (props, dispatchers, ownProps) => {
        return {
            ...ownProps, ...props, ...dispatchers,
            modelId: props.modelId
        }
    }
)(Subview);

export default RXSubview;